import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export default function Header() {
  return (
    <div className="d-flex align-items-center m-1">
      <div className="col-md-8 col-lg-9 col-sm-5 col-5">
        <h1 className="title gray-800 mb-0">
          <Link className="pointer sendto-back text-decoration-none" to="/workflow-automation">
            Automation
          </Link>
          <span> / Stopped Instances</span>
        </h1>
      </div>
    </div>
  );
}
